import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuctionValidationService } from '../../core/service/auction-validation.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionsService } from '../../core/service/auctions.service';
import { AuctionImageComponent } from './auction-image/auction-image.component';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SuccessAddItemComponent } from './success-add-item/success-add-item.component';
import { ApiRoomsService } from '../../core/service/api-rooms.service';
import { Subscription } from 'rxjs';
import { CustomValidator } from 'src/app/shared/directives/custom.validator';

@Component({
  selector: 'app-createAuction',
  templateUrl: './createAuction.component.html',
  styles: [``]
})
export class CreateAuctionComponent implements OnInit {
  @HostListener('window:resize', ['$event'])

  public picker?: MatDatepicker<Date>;

  MainInfo_Form!: FormGroup
  Details_Photos_Form!: FormGroup
  Configration_Form!: FormGroup
  files: any[] = []
  isSubmitted: boolean = false
  Title: string = this._config.translate.instant('Auctions.Add Item for Auction');
  btnSubmit: string = this._config.translate.instant("Auctions.Add Item");
  loadingData: boolean = false
  loadingCategory: boolean = false
  MainImage: any
  loading: boolean = false;
  ToDay = new Date();
  Date_Min_Max: any = { min: null, max: null };
  categoriesList!: any[]
  TimeStartMax: any
  TimeEndMin: any;
  LoadingUploadBanner: boolean = false;
  LoadingUploadMedia: boolean = false;
  AuctionItemHaveEndTime: boolean = false;
  LoadTemplate: boolean = false;
  UseDefualtValues: boolean = true;

  // Rooms Configuration
  RoomModal: any = {
    is_active: '',
    search: "",
    sort: "ASC",
    only_multi_room_upcoming: 1,
    page: 1,
    perPage: 10,
    date: moment(new Date()).format('YYYY-MM-DD')
  }
  RoomsList: any[] = [];
  RoomsPagesCount: number = 0;
  loadingRooms: boolean = false;
  formSubmited: boolean = false;
  subscriptions: Subscription[] = [];
  getScreenWidth: number = window.innerWidth;

  constructor(private fb: FormBuilder,
    private auctionValidation: AuctionValidationService,
    private auctionService: AuctionsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateAuctionComponent>,
    private _config: ConfigService,
    private dialog: MatDialog,
    private _RoomsService: ApiRoomsService) { }

  ngOnInit() {
    console.log("Test Functionality ============ >", this.MinusMinute('6:30 AM', 'plus'));
    console.log(this.data, "From Create auction component");
    this.configDates_min_max()
    this.Getcategories()
    if (this.data?.approve_request) {
      this.GetRooms(this.RoomModal);
    }
    //when in update mode
    if (this.data?.auctionId) {
      this.GetAuctionInfo(this.data.auctionId)
      this.Title = this.data.Title;
      this.btnSubmit = this.data.btnSubmit;
    }
    //when in create mode
    else {
      this.MainInfo_Form = this.fb.group(this.auctionValidation.MainInfoValidation())
      this.Details_Photos_Form = this.fb.group(this.auctionValidation.RoomDetails())
      this.Configration_Form = this.fb.group(this.auctionValidation.RoomConfigrations())
      this.MainInfo_Form.controls['room_id'].patchValue(this.data?.room_id)
      this.ListenToStart_EndTime();
    }
  }
  // checkStartTime() {
  //   const startDayAndTime: any = moment(this.MainInfo_Form.value['date']).format('YYYY-MM-DD') + ' ' + this.MainInfo_Form.value['start_at'];
  //   if (moment().isAfter(moment(startDayAndTime))) {
  //     this._config.toastrService.info("you must select a time in the future");
  //   }
  // }

  onWindowResize(event: any) {
    this.getScreenWidth = event.target.innerWidth;
  }


  onSubmit(AuctionItemHaveEndTime: boolean) {
    if (this.loading) return;


    // debugger
    console.log(this.MainInfo_Form);
    // this.formSubmited = true;
    if (this.MainInfo_Form.valid &&
      this.Details_Photos_Form.valid &&
      this.Configration_Form.valid &&
      (this.MainImage?.length || this.files)) {
      this.loading = true
      let modal = {
        ...this.MainInfo_Form.value,
        ...this.Details_Photos_Form.value,
        ...this.Configration_Form.value,
        files: [this.MainImage[0], ...this.files]
      }


      // const startDayAndTime: any = moment(this.MainInfo_Form.value['date']).format('YYYY-MM-DD') + ' ' + this.MainInfo_Form.value['start_at'];



      modal.date = moment(this.MainInfo_Form.value['date']).format('YYYY-MM-DD');



      const startDayAndTime: any = modal.date + ' ' + this.MainInfo_Form.value['start_at'];
      const dateFormat = "YYYY-MM-DD h:mm A";

      modal.start_at = moment(startDayAndTime, dateFormat).utc().format('h:mm A');
      modal.date = moment(startDayAndTime, dateFormat).utc().format('YYYY-MM-DD');

      if (moment().isAfter(moment(startDayAndTime))) {
        this._config.toastrService.clear();
        this._config.toastrService.info(this._config.translate.instant("Auction Item.you must select a time in the future"));
        this.loading = false;
        return;
      }

      if (!AuctionItemHaveEndTime) {
        modal.end_at = null;
        modal.is_reserve = false;
        modal.reserve_price = null;
      } else {
        const endDayAndTime: any = modal.date + ' ' + this.MainInfo_Form.value['end_at'];
        modal.end_at = moment(endDayAndTime, dateFormat).utc().format('h:mm A');
      }



      if (this.data?.auctionId) {
        modal.files[0].isMain = 1
        console.log(modal);
        this.auctionService.UpdateAuction(modal, this.data?.auctionId).subscribe(
          response => {
            if (this.data?.approve_request) {
              this._config.toastrService.success("Request Approved Successfully")

            } else {
              this._config.toastrService.success(response.message)

            }
            // this.loading = false
            this.dialogRef.close(true)
          },
          error => {

            this._config.showErrors(error)
            this.loading = false
          })
      } else {
        modal.files[0].isMain = 1
        console.log(modal);
        this.auctionService.addAuction(modal).subscribe(
          response => {
            this._config.toastrService.success(response.message);
            this.dialogRef.close(true);
            // this.loading = false;
            // this.onSuccessAdd();
          },
          error => {
            this._config.showErrors(error)
            this.loading = false
          })
      }

    }
  }


  GetAuctionInfo(AuctionId: string) {
    this.loadingData = true;
    const model = { id: AuctionId }
    this.subscriptions.push(this.auctionService.auctionDetailes(model).subscribe(
      (response: any) => {

        this.loadingData = false;
        const dataForm = response.data;
        if (dataForm['date'] && dataForm['date'] != "1970-01-01T00:00:00Z") { //if date have value only
          dataForm['date'] = moment(dataForm['start_date']).format('YYYY-MM-DD');
          dataForm['start_at'] = moment(dataForm['start_date']).format('hh:mm A');
          if (dataForm.end_at) {
            dataForm['end_at'] = moment(dataForm['end_date']).format('hh:mm A');
          }
        } else {
          dataForm['date'] = null;
        }
        // this.AuctionCreateForm = this.fb.group(this.auctionValidation.newAuctionFormValidation(dataForm))

        this.MainInfo_Form = this.fb.group(this.auctionValidation.MainInfoValidation(dataForm))
        this.Details_Photos_Form = this.fb.group(this.auctionValidation.RoomDetails(dataForm))
        this.Configration_Form = this.fb.group(this.auctionValidation.RoomConfigrations(dataForm))

        this.files = response.data.files.filter((file: any) => file?.isMain == 0)
        this.MainImage = response.data.files.filter((file: any) => file?.isMain == 1)
        this.data.minDate = response?.data?.room?.start_date
        this.data.maxDate = response?.data?.room?.end_date
        this.AuctionItemHaveEndTime = response.data.end_at ? true : false;
        this.configDates_min_max();
        this.RoomModal.search = response.data?.room?.name;

        if (dataForm?.category && dataForm?.is_request && dataForm?.start_at == null) {
          this.LoadCategoryTemplate(dataForm?.category?.id);
        }
        if (response.data?.is_reserve) {
          this.AuctionItemHaveEndTime = true;
        }

        this.TimeStartMax = dataForm.end_at
        this.TimeEndMin = dataForm.start_at
        this.ListenToStart_EndTime();
        // debugger
        this.data.in_multi_room = response.data?.room?.is_multi_auction
      },
      (error: any) => {
        this.loadingData = false;
        this._config.showErrors(error)
      }))
  }

  hasError(formGroup: FormGroup, controlName: string, errorName: string) {
    return formGroup.controls[controlName].hasError(errorName);
  }

  get formBtnsControls(): FormArray {
    return this.Configration_Form.controls['btns'] as FormArray
  }

  get formDetailsControls() {
    return this.Details_Photos_Form.controls['details'] as FormArray<any>
  }

  getValidity(i: number, controlName: string, errorName: string) {
    return (<FormGroup>(<FormArray>this.Details_Photos_Form.get('details')).controls[i]).controls[controlName].hasError(errorName);
  }

  addDeatilsItem(defualtValue?: any) {
    this.formDetailsControls.push(new FormGroup({
      key_en: new FormControl(defualtValue?.key_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      value_en: new FormControl(defualtValue?.value_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      key_ar: new FormControl(defualtValue?.key_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
      value_ar: new FormControl(defualtValue?.value_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)])
    }));
  }

  removeDeatilsItem(index: number) {
    (this.Details_Photos_Form.controls['details'] as FormArray).removeAt(index);
  }




  configDates_min_max() {
    this.ToDay.setHours(0)
    this.ToDay.setMinutes(0)
    this.ToDay.setSeconds(0)
    this.Date_Min_Max.min = this.ToDay > new Date(this.data.minDate) ? this.ToDay : this.data.minDate
    this.Date_Min_Max.max = this.data.maxDate
  }


  Getcategories() {
    this.loadingCategory = true;
    this.subscriptions.push(this.auctionService.getCategories().subscribe(
      response => {
        this.loadingCategory = false;
        this.categoriesList = response.data.list
      },
      error => {
        this.loadingCategory = false;
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

      }
    ))
  }


  itemSelected: number = -1;
  dropping: boolean = false

  drop(event: any) {
    const array = this.Details_Photos_Form.value.details;
    moveItemInArray(array, event.previousIndex, event.currentIndex);
    this.Details_Photos_Form.setValue({ "details": array });
  }

  // onNext(event: any, x?: any, y?: any) {
  //   console.log(event?.value);
  //   console.log(x, "main Image");
  //   console.log(y, "Medai");
  // }


  MinusMinute(time: string, operation: 'plus' | 'minus'): string {

    const time24h = this.convertTimeTo24HourFormat(time);

    var dateObj = new Date("2000-01-01T" + time24h);
    // Subtract one minute from the date object

    switch (operation) {
      case 'plus':
        dateObj?.setMinutes(dateObj.getMinutes() + 1);
        break;
      case 'minus':
        dateObj?.setMinutes(dateObj.getMinutes() - 1);
        break;
      default:
        dateObj?.setMinutes(dateObj.getMinutes() + 1);
        break;
    }
    // Format the new time as a string in the same format as the original time
    var newTime = dateObj?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    return newTime
  }



  LoadCategoryTemplate(caregoryId: string) {
    this.LoadTemplate = true;
    this.subscriptions.push(this.auctionService.getCategorytemplate(caregoryId).subscribe({
      next: (res) => {
        this.LoadTemplate = false;
        this.formBtnsControls.patchValue(res?.data?.btns)
        if (!this.Details_Photos_Form.value.details.length) {
          this.formDetailsControls.patchValue([]);
          res?.data?.templates.forEach((element: any) => {
            element.key_ar = element.name_ar
            element.key_en = element.name_en
            this.addDeatilsItem(element);
          });
        }

      },
      error: (error) => {
        this.LoadTemplate = false;
        this._config.showErrors(error);
      },
    }))
  }


  onGetSearchRoomsList(firstTime: boolean) {

    this.RoomModal.search = this.RoomModal.search ? this.RoomModal.search : '';
    if (firstTime) {
      this.RoomsList = []
      this.RoomModal.page = 1
      this.GetRooms(this.RoomModal)
    } else {
      if (this.RoomModal.page <= this.RoomsPagesCount - 1) {
        this.RoomModal.page += 1;
        this.GetRooms(this.RoomModal)
      }
    }
  }


  GetRooms(modal: any) {
    this.loadingRooms = true;
    this.subscriptions.push(this._RoomsService.allRoomForAdmin(modal).subscribe({
      next: (res) => {
        this.loadingRooms = false;
        this.RoomsList = this.RoomsList.concat(res.data.list);
        this.RoomsPagesCount = res?.data?.total_upcoming
      }, error: (error) => {
        this.loadingRooms = false;
        this._config.showErrors(error)
      }
    }))
  }


  OnSelectRoom(room: any) {
    this.data.minDate = room?.start_date
    this.data.maxDate = room?.end_date
    this.data.in_multi_room = room.is_multi_auction
    if (this.data.in_multi_room) {
      this.Configration_Form.controls['is_reserve'].patchValue(false);
    }

    // this.AuctionItemHaveEndTime = room.end_at ? true : false;
    this.configDates_min_max();
    this.MainInfo_Form.controls['room_id'].patchValue(room?.id)

  }

  ListenToStart_EndTime() {

    this.MainInfo_Form.controls['start_at'].valueChanges.subscribe(data => {
      console.log("Before", data);

      this.TimeEndMin = this.MinusMinute(data?.toString(), 'plus')
      console.log("After", this.TimeEndMin);
    })
    this.MainInfo_Form.controls['end_at'].valueChanges.subscribe(data => {
      console.log("Before", data);
      this.TimeStartMax = this.MinusMinute(data?.toString(), 'minus')
      console.log("After", this.TimeStartMax);

    })
  }

  btns_hasError(index: number, controlName: string, Validator: string) {
    return this.formBtnsControls.at(index).get(controlName)?.hasError(Validator);
  }


  convertTimeTo24HourFormat(time: string) {
    // Extract the hours, minutes, and AM/PM indicator from the input time
    const [hours, minutes, indicator] = time.split(/:| /);

    // Convert the hours to a number
    let hour = parseInt(hours, 10);

    // If the indicator is "PM" and the hour is not 12, add 12 to the hour
    if (indicator === "PM" && hour !== 12) {
      hour += 12;
    }

    // If the indicator is "AM" and the hour is 12, set the hour to 0
    if (indicator === "AM" && hour === 12) {
      hour = 0;
    }

    // Return the time in 24-hour format
    return `${hour.toString().padStart(2, "0")}:${minutes}`;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
  }

}
